// axios
import axios from 'axios'

let axiosSecure = axios.create({
  baseURL: process.env.VUE_APP_API
});

if(JSON.parse(localStorage.getItem('userData'))){
  axiosSecure.defaults.headers.common['Authorization'] = 'Bearer ' + JSON.parse(localStorage.getItem('userData')).token;
}
axiosSecure.defaults.headers.common['Accept'] = 'application/json';

export default axiosSecure;
